import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { SectionHeadingBlock } from "@/puck/landing/sectionHeadingBlock";

export const sectionHeadingConfigs: Pick<LandingComponents, "SectionHeading"> = {
  SectionHeading: {
    label: "Section heading",
    fields: {
      eyebrow: { type: "text", contentEditable: true },
      title: {
        type: "text",
        label: "Title (wrap highlights in <em> tags)",
        contentEditable: true,
      },
      subtitle: { type: "textarea", contentEditable: true },
      align: {
        type: "radio",
        label: "Alignment",
        options: [
          { label: "Left", value: "left" },
          { label: "Center", value: "center" },
        ],
      },
    },
    defaultProps: {
      eyebrow: "SEE IT RUN",
      title: "And the paperwork? <em>Filled while you watch.</em>",
      subtitle:
        "Gail completes a Certificate of Insurance and ACORD 25 end to end — pulling from your book, no template wrangling.",
      align: "left",
    },
    render: SectionHeadingBlock,
  },
};
